@if ((filesListOpen && entity) || renderMode === 'web-app') {
  <article
    id="{{ renderMode }}"
    class="box-files-container mbv-article"
    xmlns="http://www.w3.org/1999/html"
    >
    <h3 class="box-title-bar heading-underline">
      <mat-icon fontIcon="merge_type" class="mbv-title-icon"></mat-icon>
      <span class="mbv-title-text">
        Merge
        @if (!entityName) {
          <span>Basket</span>
        }
        @if (entityName) {
          <span> to {{ entityName }}</span>
        }
      </span>
      <span class="mbv-titlebar-icons">
        @if (showSyncIcon) {
          <mat-icon
            fontIcon="cached"
            class="mbv-title-icon sync"
            [matTooltip]="'Synchronise with the current record'"
            matTooltipShowDelay="500"
            role="button"
            (click)="syncEntity()"
            tabindex="0"
            (keydown.enter)="syncEntity()"
            (keydown.space)="syncEntity()"
            ></mat-icon
            >
            }<!-- sync_alt? -->
            <span
              class="basket-size"
              [ngClass]="[files.length > 1 ? 'valid-basket-size' : '']"
              [matTooltip]="files.length > 1 ? files.length + ' files to merge' : 'At least 2 files are needed to merge'"
              matTooltipShowDelay="500"
              >{{ files.length }}</span
              >
              @if (totalFileSizeBytes > maxBasketFileSizeBytes) {
                <mat-icon
                  class="warning"
                  fontIcon="error_outline"
        [matTooltip]="
          'Your Merge Basket size is ' + (totalFileSizeBytes | TransformBytesToMB) + ' of a maximum 20MB. Please remove some files.'
        "
                  matTooltipShowDelay="500"
                ></mat-icon>
              }
            </span>
          </h3>
          @if (showDropArea) {
            <div
              [ngClass]="viewDropClass"
              (drop)="onDrop($event)"
              (dragover)="onDragOver($event)"
              (dragend)="onDragEnd($event)"
              (dragleave)="onDragEnd($event)"
              >
              <h3><span class="mbv-dropMessage">DROP FILES HERE</span></h3>
            </div>
          }
          <div [ngClass]="viewBasketClass" (dragenter)="onDragOver($event)">
            <div class="mbv-merge-name merge-name-grid">
              <span>MERGE NAME</span>
              <input
                [ngClass]="mergeName === '' ? 'mbv-name-input empty' : 'mbv-name-input'"
                type="text"
                (input)="mergeNameInput($event)"
                placeholder="Merge name"
                matTooltip="Enter a file name for the merged file"
                matTooltipShowDelay="500"
                />
                <span>.PDF</span>
              </div>
              @if (files.length === 0 && renderMode === 'chrome-extension') {
                <span class="mbv-subtitle-text placeholder-text"
                  >ADD FILES FROM ABOVE OR UPLOAD TO INCLUDE IN A MERGE</span
                  >
              }
              @if (files.length === 0 && renderMode === 'web-app') {
                <span class="mbv-subtitle-text placeholder-text"
                  >ADD FILES FROM AN ENTITY OR UPLOAD TO INCLUDE IN A MERGE</span
                  >
                }
                <!--<div *ngIf="!mergeValid" class="mbv-no-files-text">*Merge name and at least 2 files required</div> -->
                @if (files.length !== 0) {
                  <div class="mbv-table-container">
                    <app-kp-simple-table
                      [items]="files"
                      [columnHeadings]="columnHeadings"
                      [canReorder]="true"
                      (itemsReordered)="itemsReordered($event)"
                      [tableClasses]="'hover-rows'"
                      (actionClick)="itemActionClick($event)"
                      (rowDoubleClick)="itemRowDoubleClick($event)"
                      >
                    </app-kp-simple-table>
                  </div>
                }
                @if (files.length > 0) {
                  <a
                    class="clear-table" role="button"
                    [matTooltip]="'Empty merge basket'" matTooltipShowDelay="500" tabindex="0"
                    (click)="clearBasket()">
                    Clear all
                  </a>
                }
                <section class="footer-btns">
                  <aside>
                    <input
                      style="display: none"
                      type="file"
                      accept="{{ uploadableFileExtensions }}"
                      (change)="uploadFile($event.target)"
                      (click)="fileUpload.value = null"
                      multiple
                      #fileUpload
                      />
                      <button class="mbv-upload-button upload" [disabled]="!currentUserId" (click)="fileUpload.click()" appRipple>
                        UPLOAD TO BASKET
                        <mat-icon fontIcon="file_upload" style="vertical-align: top"></mat-icon>
                      </button>
                    </aside>
                    <div class="tooltip-container" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
                      <button (click)="mergeFiles()" class="mbv-merge-button" [disabled]="!mergeValid" appRipple>
                        MERGE
                        <mat-icon fontIcon="merge_type" style="vertical-align: top"></mat-icon>
                      </button>
                      @if (tooltipVisible && mergeTooltip) {
                        <div class="supertooltiptext" [innerHTML]="mergeTooltip"></div>
                      }
                    </div>
                  </section>
                </div>
              </article>
            }
